import BaseService from "../../base/base_service";
import IPlayerMigration, {IPlayerMigrationProxyService} from "../../../../common/interfaces/player-migration.interface";
import {ClientVisitAnalyticsParams} from "../../../../app-react/services/player-migration/player-migration.service";

interface PlayerMigrationProxyServiceParams {
    getPlayerMigrationService: () => IPlayerMigration;
}

export default class PlayerMigrationProxyService extends BaseService implements IPlayerMigrationProxyService {
    static CLASS = 'PlayerMigrationProxyService';
    private _params: PlayerMigrationProxyServiceParams;

    init(params: PlayerMigrationProxyServiceParams) {
        this._params = params;
    }

    get businessCorrelationId(): string {
        return this._params.getPlayerMigrationService().businessCorrelationId;
    }

    get isMigrationEnabledFromConfig(): boolean {
        return this._params.getPlayerMigrationService().isMigrationEnabledFromConfig;
    }

    get isPlayerMigrated(): boolean {
        return this._params.getPlayerMigrationService().isPlayerMigrated;
    }

    sendClientVisitAnalytics(params?: ClientVisitAnalyticsParams) {
        return this._params.getPlayerMigrationService().sendClientVisitAnalytics(params);
    }
}